import 'reflect-metadata'
import 'src/styles/index.scss'
import ReactDOM from 'react-dom'
import App from 'src/app'
import { datadogLogs } from '@datadog/browser-logs'
import { dispatchPaddleCheckoutEvent } from 'src/modules/payment/utils/paddle-checkout-events'

// Show app deployment metadata
console.log(
  `App version: ${import.meta.env.VITE_HEROKU_SLUG_COMMIT || 'development'}, deployed on ${
    import.meta.env.VITE_HEROKU_RELEASE_CREATED_AT || 'unknown'
  }`,
)

if (import.meta.env.VITE_DD_ENABLED === 'true') {
  datadogLogs.init({
    service: 'frontend',
    env: import.meta.env.VITE_ENVIRONMENT || import.meta.env.MODE || 'development',
    clientToken: import.meta.env.VITE_DD_CLIENT_TOKEN,
    site: import.meta.env.VITE_DD_SITE,
    forwardConsoleLogs: [/*'debug', 'log', 'info',*/ 'warn', 'error'],
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
  })
}

// Initialize Paddle when script loads
const initPaddle = () => {
  if (typeof window !== 'undefined' && (window as any).Paddle) {
    const isTestMode = import.meta.env.VITE_PADDLE_TEST_MODE === 'true'
    const vendor = import.meta.env.VITE_PADDLE_VENDOR_ID

    if (isTestMode) {
      ;(window as any).Paddle.Environment.set('sandbox')
    }

    if (vendor) {
      ;(window as any).Paddle.Setup({
        vendor: parseInt(vendor, 10),
        eventCallback: dispatchPaddleCheckoutEvent,
      })
    }
  } else if (typeof window !== 'undefined') {
    // Wait for Paddle script to load
    setTimeout(initPaddle, 100)
  }
}

// Start initialization
initPaddle()

// Load Popupsmart if configured
if (import.meta.env.VITE_POPUPSMART_DATA_ID) {
  const script = document.createElement('script')
  script.src = 'https://cdn.popupsmart.com/bundle.js'
  script.setAttribute('data-id', import.meta.env.VITE_POPUPSMART_DATA_ID)
  script.async = true
  script.defer = true
  document.body.appendChild(script)
}

ReactDOM.render(<App />, document.getElementById('root'))

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
